import { render } from "./ProfilePanelCoverImage.vue?vue&type=template&id=46a520bb&scoped=true"
import script from "./ProfilePanelCoverImage.vue?vue&type=script&lang=js"
export * from "./ProfilePanelCoverImage.vue?vue&type=script&lang=js"

import "./ProfilePanelCoverImage.vue?vue&type=style&index=0&id=46a520bb&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a520bb"]])

export default __exports__